import React from "react";
import { Church, Wine, MapPin, Calendar } from "lucide-react";

const HomeMain = ({ t }) => {
  return (
    <section className="home-main">
      <div className="container">
        {/* 1. SEKCIJA: IMENA I DATUM */}
        <div className="header-top">
          <h1 className="script-font">Matea + Reinier</h1>
          <div className="date-divider">
            <Calendar size={16} strokeWidth={1.5} className="icon-sep" />
            <span className="serif-font">04.07.2026</span>
          </div>
        </div>

        {/* 2. SEKCIJA: SLIKA */}
        <div className="image-wrapper">
          <img
            src="https://images.unsplash.com/photo-1583939003579-730e3918a45a?q=80&w=1974&auto=format&fit=crop"
            alt="Matea & Reinier"
          />
          <div className="image-border"></div>
        </div>

        {/* 3. SEKCIJA: DETALJI S IKONAMA */}
        <div className="details-bottom">
          <h2 className="serif-font">Matea Nikolić & Reinier Van Bergen</h2>

          <p className="intro-text">{t.homeIntro}</p>

          <div className="info-grid">
            {/* Ceremonija */}
            <div className="info-item">
              <div className="icon-circle">
                <Church size={28} strokeWidth={1} />
              </div>
              <h3 className="serif-font">{t.homeCeremonyTitle}</h3>
              <p>
                {t.homeCeremonyLocation}
                <br />
                {t.homeCeremonyTime}
              </p>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noreferrer"
                className="map-link"
              >
                <MapPin size={12} /> {t.homeViewMap}
              </a>
            </div>

            {/* Proslava */}
            <div className="info-item">
              <div className="icon-circle">
                <Wine size={28} strokeWidth={1} />
              </div>
              <h3 className="serif-font">{t.homeCelebrationTitle}</h3>
              <p>
                {t.homeCelebrationLocation}
                <br />
                {t.homeCelebrationTime}
              </p>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noreferrer"
                className="map-link"
              >
                <MapPin size={12} /> {t.homeViewMap}
              </a>
            </div>
          </div>

          <p className="rsvp-note">{t.homeRsvpNote}</p>
        </div>
      </div>
    </section>
  );
};

export default HomeMain;
